import { useBooleanState } from '@calendly/hooks'
import { useContext } from 'react'

import { useTrack } from 'hooks/analytics_events'
import { isCalendlyMeeting } from 'shared/utils'

import { MeetingDetailDependenciesContext } from '../../../meeting_detail_context'

const useNoOp = () => [() => {}]

export const useNoShow = ({ invitee, event, onMarkAsNoShow }) => {
  const dependencies = useContext(MeetingDetailDependenciesContext)
  const useMarkMutation = dependencies?.useMarkInviteeAsNoShowMutation ?? useNoOp
  const useUndoMutation = dependencies?.useUndoNoShowForInviteeMutation ?? useNoOp

  const track = useTrack()
  const [markAsNoShow] = useMarkMutation()
  const [undoNoShow] = useUndoMutation()
  const [isModalOpen, openModal, closeModal] = useBooleanState(false)

  const sendAnalytics = (action) => {
    track({
      name: 'Meeting Interaction',
      properties: {
        action,
        location: 'meetings_page_right_rail',
        event_uuid: event.uuid,
        mi_event_uuid: event.meetingIntelligence?.uuid,
        is_calendly_meeting: isCalendlyMeeting(event),
      }
    })
  }

  const handleMarkNoShow = () => {
    closeModal()
    markAsNoShow({ id: invitee.id, eventId: event.id })
    sendAnalytics('mark_no_show')
    if (onMarkAsNoShow) onMarkAsNoShow()
  }

  const handleUndoNoShow = (e) => {
    e?.stopPropagation()
    undoNoShow({ id: invitee.id, eventId: event.id })
    sendAnalytics('mark_no_show_undo')
  }

  const handleNoShowClick = (e) => {
    e?.stopPropagation()
    openModal()
  }

  return {
    isModalOpen,
    closeModal,
    handleMarkNoShow,
    handleUndoNoShow,
    handleNoShowClick,
  }
}
